var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.31 116.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.31,57.55A34.16,34.16,0,1,1,60.81,24C79.65,23.84,95.16,38.94,95.31,57.55Zm-52,20,.75-.22c3.1-1,6.19-2,9.3-2.93a1.58,1.58,0,0,1,1,.08A19.57,19.57,0,0,0,66,76.4a19,19,0,0,0,15.23-25A19.21,19.21,0,0,0,55.58,40.16a18.81,18.81,0,0,0-9.92,25.06,5.58,5.58,0,0,1,.21,4.89C44.9,72.51,44.17,75,43.29,77.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.12,72.92c.63-1.9,1.19-3.64,1.8-5.36a1.1,1.1,0,0,0-.15-1.08,15.78,15.78,0,0,1,.12-17.93,16,16,0,1,1,4.88,22.73,1.49,1.49,0,0,0-1.08-.11C51.87,71.7,50.08,72.3,48.12,72.92ZM57.18,49v-.18a5.29,5.29,0,0,0-1.48.52A4.53,4.53,0,0,0,54,51.8a6.12,6.12,0,0,0,.78,5c2.75,4.75,6.52,8.21,12,9.55a5.2,5.2,0,0,0,2.71.08c2.33-.68,3.31-1.84,3.35-3.85a1.05,1.05,0,0,0-.39-.8c-1.22-.64-2.47-1.22-3.71-1.81a.86.86,0,0,0-1.19.33,11.46,11.46,0,0,1-1.39,1.65,1,1,0,0,1-.9.21,12.57,12.57,0,0,1-6.44-5.41.79.79,0,0,1,.09-1.07c.3-.32.59-.65.86-1A1.49,1.49,0,0,0,60,53c-.45-.94-.83-1.92-1.21-2.9C58.51,49.33,58.14,48.75,57.18,49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/WHATSAPP.9c46abcba7950f14a5fa4eafe8769779.svg";
export { ForwardRef as ReactComponent };